import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
const URLhausAdapterFieldSet = ({
  config,
  handleFormEvent,
  validationMessage,
  validationState
}) => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "select",
      id: "feed_type",
      name: "feed_type",
      label: t("urlhaus.fields.feed_type"),
      onChange: handleFormEvent,
      help: validationMessage("feed_type", t("urlhaus.fields.feed_type_help")),
      bsStyle: validationState("feed_type"),
      value: config.feed_type,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      required: true
    },
    /* @__PURE__ */ React.createElement("option", { key: "ONLINE_ONLY", value: "ONLINE_ONLY" }, t("urlhaus.feed_types.online_only")),
    /* @__PURE__ */ React.createElement("option", { key: "RECENT_ADDITIONS", value: "RECENT_ADDITIONS" }, t("urlhaus.feed_types.recent_additions"))
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "refresh_interval",
      name: "refresh_interval",
      label: t("common.fields.refresh_interval_seconds"),
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("refresh_interval", t("urlhaus.fields.refresh_interval_help")),
      bsStyle: validationState("refresh_interval"),
      value: config.refresh_interval,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "case_insensitive_lookup",
      name: "case_insensitive_lookup",
      label: t("common.fields.case_insensitive_lookups"),
      checked: config.case_insensitive_lookup,
      onChange: handleFormEvent,
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ));
};
export default URLhausAdapterFieldSet;
